var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinderAiSignet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 40,
    viewBox: "0 0 34 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8169 4.05046H24.6533V7.13204L27.7351 7.13203V10.2137H18.4901V7.13203L21.5716 7.13204V4.05046H6.22475e-05V0.968796H33.8984V4.05046L33.8986 4.05046L33.8986 16.3771H30.8169V16.377H24.6533H18.4901H12.3266V13.2953H18.4901H24.6533H30.8169V4.05046ZM15.4084 41.0304H6.22475e-05V37.9488H12.3266L12.3266 28.7037H6.16356V25.6221H12.3269V25.6222H15.4083L15.4083 37.9488H15.4084V41.0304ZM6.22475e-05 7.13204V10.2137L6.10352e-05 34.867H3.08173L3.08173 10.2137H15.4084V7.13203H6.22475e-05V7.13204ZM15.4083 28.7037H27.735L27.735 25.6222V19.4588H24.6533V25.6221H15.4083V28.7037ZM15.6326 22.5404H21.5716V19.4587H15.6326H12.3266L9.24522 19.4588V13.2954H6.16356V19.4588L3.08182 19.4587V22.5404H12.3266H15.6326ZM9.24516 34.8671H3.08182V31.7854H9.24516V34.8671ZM24.6533 19.4588H27.735V16.3771H24.6533V19.4588Z",
    fill: "url(#paint0_linear_2041_617)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2041_617",
    x1: 35.1241,
    y1: 5.684,
    x2: -3.46758,
    y2: 42.0453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616666,
    stopColor: "#1FB2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#012F80"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinderAiSignet);
export default __webpack_public_path__ + "static/media/finder-ai-signet.f022865c95569f1ce48f8d4a65394c61.svg";
export { ForwardRef as ReactComponent };